import React, { useContext, useState, useEffect } from "react";
import CampaignContext from "../../../contexts/CampaignContext";
import SKUTrends from "./SKUTrends";
import OutletsPerformance from "./OutletsPerformance";
import GeneralBrandPerformance from "./GeneralBrandPerformance";
import LocationPerbrandPerformance from "./LocationPerbrand";
import restService from "../../../restService";
const Insights = () => {
  const [campaign] = useContext(CampaignContext);
  const [brands, setBrands] = useState([]);
  const [outlets, setOutlets] = useState([]);

  const handleGetBrands = async () => {
    try {
      const {
        data: { data },
      } = await restService.Insights.getBrandsInsights(
        campaign?.id,

        "2022-10-01",
        "2022-11-07"
      );

      let tempCat = [];

      for (let i = 0; i < data.length; i++) {
        tempCat.push({ value: data[i].brand, label: data[i].brand });
      }

      setBrands(tempCat);
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetOutlets = async () => {
    try {
      const {
        data: { data },
      } = await restService.Insights.getLocationPerBrand(
        campaign?.id,

        "2022-10-01",
        "2022-11-07"
      );

      let tempCat = [];

      for (let i = 0; i < data.length; i++) {
        tempCat.push();
        tempCat.push({
          value: data[i].location,
          label: data[i].location.replace("MELCOM", ""),
        });
      }

      setOutlets(tempCat);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetBrands();
    handleGetOutlets();
  }, []);

  return (
    <div className="h-full px-4 md:px-8 w-full">
      <h1 className=" text-[24px] leading-9 font-[600]">Insights</h1>
      <div className="flex flex-col gap-8 mt-8">
        <SKUTrends brands={brands} />

        {/* <OutletsPerformance /> */}

        <GeneralBrandPerformance allOutlets={outlets} brands={brands} />

        <LocationPerbrandPerformance brands={brands} />
      </div>
    </div>
  );
};

export default Insights;
